import { gql, TypedDocumentNode } from "@apollo/client";

export type CareerConsultantSection = {
  id: string;
  name: string;
  legacyId: string | null;
};

export type MeCareerConsultantSectionsResponse = {
  me: { id: string } | null;
  careerConsultantSections: CareerConsultantSection[];
};

export const ME_CAREER_CONSULTANT_SECTIONS_QUERY: TypedDocumentNode<MeCareerConsultantSectionsResponse> = gql`
  query MeCareerConsultantSections {
    me {
      id
    }
    careerConsultantSections {
      id
      name
      legacyId
    }
  }
`;
